import React from 'react';
import './App.css';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import UserTypes from './components/UserTypes';
import Features from './components/Features';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Hero />
      <div id="story">
        <UserTypes />
      </div>
      <div id="how-it-works">
        <HowItWorks />
      </div>
      <div id="travel">
        <Features />
      </div>
      <Footer />
    </div>
  );
}

export default App;
